// import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
var root = process.env.API_ROOT;


const state ={
  userCount:'',
  webNotice:'',
}

const mutations = {
  userinfo(state){
    var isUser = localStorage.getItem("BLHuser")
    $.ajax({
      type: 'POST',
      url: root + '/WebApi/Member/Info/index',
      data: {token: isUser},
      success: function (res) {
        if (JSON.parse(res).errCode == '0000') {
          state.userCount = JSON.parse(res).data.memberinfo
          // console.log('个人中心请求')
        } else {

        }
      },
      error: function (err) {
      }
    })
  },
}

export default new Vuex.Store({
  state,
  mutations,
})



// WEBPACK FOOTER //
// ./src/vuex/store.js